import { ValidationObserver, ValidationProvider } from 'vee-validate'
import WeekdaySelector from '@/components/weekdaySelector/WeekdaySelector.vue'

export default {
  name: 'AddEditShift',
  components: {
    ValidationObserver,
    ValidationProvider,
    WeekdaySelector,
  },
  data() {
    return {
      id: null,
      name: null,
      code: null,
      start_time: null,
      end_time: null,
      working_hours: null,

      minimum_full_day_hours: '00:00',
      grace_period_start_hours: '00:00',
      half_day_hours: '00:00',

      working_days: [],
      weekly_off_days: [],
      grace_minutes: null,
      grace_days_allowed: null,
      lunch_break_minutes: null,
      status: true,
      btnLoader: false,
      endTimeError: false,
      minFullDayError: false,
      gracePeriodStartError: false,
      halfDayError: false,
      minFullDayOverError: false,
      gracePeriodStartOverError: false,
      halfDayOverError: false,
      workingDaysError: false,
      workingDayOverlapError: false,
      weeklyOffOverlapError: false,
      dayOptions: [
        { label: 'Monday', value: 1 },
        { label: 'Tuesday', value: 2 },
        { label: 'Wednesday', value: 3 },
        { label: 'Thursday', value: 4 },
        { label: 'Friday', value: 5 },
        { label: 'Saturday', value: 6 },
        { label: 'Sunday', value: 7 },
      ],
    }
  },
  computed: {
    maxAllowedTime() {
      if (!this.start_time || !this.end_time) return null

      const [sh, sm] = this.start_time.split(':').map(Number)
      const [eh, em] = this.end_time.split(':').map(Number)
      const diffMins = (eh * 60 + em) - (sh * 60 + sm)

      if (diffMins <= 0) return null

      const lunchMins = Number(this.lunch_break_minutes || 0)
      const finalMins = Math.max(0, diffMins - lunchMins)

      const h = Math.floor(finalMins / 60)
      const m = finalMins % 60
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    },
  },
  watch: {
    working_days(newVal) {
      // Auto-remove off-days that now overlap with working days
      if (this.weekly_off_days && this.weekly_off_days.length) {
        this.weekly_off_days = this.weekly_off_days.filter(
          d => !(newVal || []).includes(d),
        )
      }
      this.workingDaysError = false
      this.workingDayOverlapError = false
      this.weeklyOffOverlapError = false
    },
    weekly_off_days() {
      this.weeklyOffOverlapError = false
      this.workingDayOverlapError = false
    },
  },
  methods: {
    handleTimeKeydown(e, field) {
      const input = e.target
      let val = input.value || '00:00'
      const allowedKeys = ['Tab', 'ArrowLeft', 'ArrowRight', 'Enter']
      if (e.ctrlKey || e.metaKey || allowedKeys.includes(e.key)) return

      e.preventDefault()

      if (e.key === 'ArrowUp') {
        this.incrementTime(field)
        return
      } else if (e.key === 'ArrowDown') {
        this.decrementTime(field)
        return
      }

      const start = input.selectionStart
      const end = input.selectionEnd

      if (e.key === 'Backspace') {
        if (start !== end) {
          this.zeroOutSelection(val, start, end, field, input, start)
        } else if (start > 0) {
          let pos = start
          if (val[pos - 1] === ':') pos--
          if (pos > 0) {
            const arr = val.split('')
            arr[pos - 1] = '0'
            this[field] = arr.join('')
            this.$nextTick(() => input.setSelectionRange(pos - 1, pos - 1))
          }
        }
      } else if (e.key === 'Delete') {
        if (start !== end) {
          this.zeroOutSelection(val, start, end, field, input, start)
        } else if (start < 5) {
          let pos = start
          if (val[pos] === ':') pos++
          if (pos < 5) {
            const arr = val.split('')
            arr[pos] = '0'
            this[field] = arr.join('')
            this.$nextTick(() => input.setSelectionRange(pos + 1, pos + 1))
          }
        }
      } else if (/^[0-9]$/.test(e.key)) {
        if (start !== end) {
          const arr = val.split('')
          for (let i = start; i < end; i++) {
            if (arr[i] !== ':') arr[i] = '0'
          }
          let pos = start
          if (arr[pos] === ':') pos++
          if (pos < 5) arr[pos] = e.key
          this[field] = arr.join('')
          this.$nextTick(() => input.setSelectionRange(pos + 1, pos + 1))
        } else {
          let pos = start
          if (val[pos] === ':') pos++
          if (pos < 5) {
            const arr = val.split('')
            arr[pos] = e.key
            this[field] = arr.join('')
            this.$nextTick(() => input.setSelectionRange(pos + 1, pos + 1))
          }
        }
      }
    },

    zeroOutSelection(val, start, end, field, input, cursorAfter) {
      const arr = val.split('')
      for (let i = start; i < end; i++) {
        if (arr[i] !== ':') arr[i] = '0'
      }
      this[field] = arr.join('')
      this.$nextTick(() => input.setSelectionRange(cursorAfter, cursorAfter))
    },

    incrementTime(field, step = 1) {
      let val = this[field] || '00:00'
      let [h, m] = val.split(':').map(Number)
      m += step
      while (m >= 60) {
        m -= 60
        h += 1
      }
      if (h > 99) h = 99 // cap at 99 hours
      this[field] = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`

      if (field === 'grace_period_start_hours') {
        this.gracePeriodStartError = false
        this.gracePeriodStartOverError = false
      } else if (field === 'minimum_full_day_hours') {
        this.minFullDayError = false
        this.minFullDayOverError = false
      } else {
        this.halfDayError = false
        this.halfDayOverError = false
      }
    },

    decrementTime(field, step = 1) {
      let val = this[field] || '00:00'
      let [h, m] = val.split(':').map(Number)
      if (h === 0 && m === 0) return
      m -= step
      while (m < 0) {
        if (h > 0) {
          m += 60
          h -= 1
        } else {
          m = 0
        }
      }
      this[field] = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`

      if (field === 'grace_period_start_hours') {
        this.gracePeriodStartError = false
        this.gracePeriodStartOverError = false
      } else if (field === 'minimum_full_day_hours') {
        this.minFullDayError = false
        this.minFullDayOverError = false
      } else {
        this.halfDayError = false
        this.halfDayOverError = false
      }
    },

    // ── Sidebar open / reset ─────────────────────────────────

    open(item = null) {
      if (item) {
        this.id = item.id
        this.name = item.name
        this.code = item.code
        this.start_time = item.start_time ? item.start_time.substring(0, 5) : null
        this.end_time = item.end_time ? item.end_time.substring(0, 5) : null
        this.working_days = item.working_days ? [...item.working_days] : []
        this.weekly_off_days = item.weekly_off_days ? [...item.weekly_off_days] : []
        this.grace_minutes = item.grace_minutes
        this.grace_days_allowed = item.grace_days_allowed ?? 2
        this.lunch_break_minutes = item.lunch_break_minutes != null ? item.lunch_break_minutes : null
        this.status = item.is_active === 1 || item.is_active === true

        this.minimum_full_day_hours = this.decimalToTime(item.minimum_full_day_hours) || '00:00'
        this.grace_period_start_hours = item.grace_period_start_hours ? this.decimalToTime(item.grace_period_start_hours) : '00:00'
        this.half_day_hours = this.decimalToTime(item.half_day_hours) || '00:00'

        // Populate working hours from backend or calculate on-the-fly
        if (item.total_working_hours !== undefined && item.total_working_hours !== null) {
          const totalMins = Math.round(item.total_working_hours * 60)
          const h = Math.floor(totalMins / 60)
          const m = totalMins % 60
          this.working_hours = m > 0 ? `${h}h ${m}m` : `${h}h`
        } else if (item.working_hours) {
          this.working_hours = item.working_hours
        } else {
          this.calculateWorkingHours()
        }
      }
      this.$root.$emit('bv::toggle::collapse', 'addEditShift')
    },

    sidebarToggle() {
      this.id = null
      this.name = null
      this.code = null
      this.start_time = null
      this.end_time = null
      this.working_hours = null
      this.minimum_full_day_hours = '00:00'
      this.grace_period_start_hours = '00:00'
      this.half_day_hours = '00:00'
      this.working_days = []
      this.weekly_off_days = []
      this.grace_minutes = null
      this.grace_days_allowed = 2
      this.lunch_break_minutes = null
      this.status = true
      this.endTimeError = false
      this.minFullDayError = false
      this.gracePeriodStartError = false
      this.halfDayError = false
      this.minFullDayOverError = false
      this.gracePeriodStartOverError = false
      this.halfDayOverError = false
      this.workingDaysError = false
      this.workingDayOverlapError = false
      this.weeklyOffOverlapError = false
      this.$refs.shiftObserver.reset()
    },

    // ── Working hours calculation ────────────────────────────

    calculateWorkingHours() {
      this.endTimeError = false
      this.working_hours = null
      if (!this.start_time || !this.end_time) return

      const [sh, sm] = this.start_time.split(':').map(Number)
      const [eh, em] = this.end_time.split(':').map(Number)
      const startMins = sh * 60 + sm
      const endMins = eh * 60 + em

      if (endMins <= startMins) {
        this.endTimeError = true
        return
      }

      const diffMins = endMins - startMins
      const lunchMins = Number(this.lunch_break_minutes || 0)
      const finalMins = Math.max(0, diffMins - lunchMins)

      const hours = Math.floor(finalMins / 60)
      const mins = finalMins % 60
      this.working_hours = mins > 0 ? `${hours}h ${mins}m` : `${hours}h`
    },

    // ── Validation ───────────────────────────────────────────

    validateDayOverlap() {
      if (!this.working_days || !this.weekly_off_days) return true
      const overlap = this.working_days.some(d => this.weekly_off_days.includes(d))
      if (overlap) {
        this.workingDayOverlapError = true
        this.weeklyOffOverlapError = true
        return false
      }
      return true
    },

    validateDurations() {
      let valid = true

      const getMaxTimeMins = timeStr => {
        if (!timeStr) return null
        const [h, m] = timeStr.split(':').map(Number)
        return h * 60 + (m || 0)
      }

      const maxTimeMins = this.maxAllowedTime ? getMaxTimeMins(this.maxAllowedTime) : null

      if (this.minimum_full_day_hours !== null && this.minimum_full_day_hours !== '') {
        const fullDayMins = getMaxTimeMins(this.minimum_full_day_hours)
        if (fullDayMins <= 0) {
          this.minFullDayError = true
          valid = false
        } else if (maxTimeMins !== null && fullDayMins > maxTimeMins) {
          this.minFullDayOverError = true
          valid = false
        }
      }

      if (this.grace_period_start_hours !== null && this.grace_period_start_hours !== '') {
        const graceMins = getMaxTimeMins(this.grace_period_start_hours)
        if (graceMins <= 0) {
          this.gracePeriodStartError = true
          valid = false
        } else if (maxTimeMins !== null && graceMins > maxTimeMins) {
          this.gracePeriodStartOverError = true
          valid = false
        }
      }

      if (this.half_day_hours !== null && this.half_day_hours !== '') {
        const halfDayMins = getMaxTimeMins(this.half_day_hours)
        if (halfDayMins <= 0) {
          this.halfDayError = true
          valid = false
        } else if (maxTimeMins !== null && halfDayMins > maxTimeMins) {
          this.halfDayOverError = true
          valid = false
        }
      }

      return valid
    },

    validateWorkingDays() {
      if (!this.working_days || !this.working_days.length) {
        this.workingDaysError = true
        return false
      }
      this.workingDaysError = false
      return true
    },

    validationForm() {
      const isWorkingDaysValid = this.validateWorkingDays()
      const isDayOverlapValid = this.validateDayOverlap()
      const isDurationsValid = this.validateDurations()

      this.$refs.shiftObserver.validate().then(success => {
        if (
          success &&
          !this.endTimeError &&
          isWorkingDaysValid &&
          isDayOverlapValid &&
          isDurationsValid
        ) {
          this.saveShift()
        }
      })
    },

    // ── API ──────────────────────────────────────────────────

    toTimeWithSeconds(hhmm) {
      if (!hhmm) return null
      return hhmm.length === 5 ? `${hhmm}:00` : hhmm
    },

    timeToDecimal(timeStr) {
      if (!timeStr) return null
      const [h, m] = timeStr.split(':').map(Number)
      if (isNaN(h) || isNaN(m)) return null
      return +(h + (m / 60)).toFixed(2)
    },

    decimalToTime(decimal) {
      if (decimal === null || decimal === undefined || decimal === '') return '00:00'
      const d = Number(decimal)
      if (isNaN(d)) return '00:00'
      const h = Math.floor(d)
      const m = Math.round((d - h) * 60)
      const hh = String(h).padStart(2, '0')
      const mm = String(m).padStart(2, '0')
      return `${hh}:${mm}`
    },

    async saveShift() {
      this.btnLoader = true

      const input = {
        name: this.name,
        code: this.code,
        start_time: this.toTimeWithSeconds(this.start_time),
        end_time: this.toTimeWithSeconds(this.end_time),
        working_hours: this.working_hours,
        minimum_full_day_hours: this.timeToDecimal(this.minimum_full_day_hours),
        grace_period_start_hours: this.timeToDecimal(this.grace_period_start_hours),
        half_day_hours: this.timeToDecimal(this.half_day_hours),
        working_days: this.working_days,
        weekly_off_days: this.weekly_off_days,
        grace_minutes: Number(this.grace_minutes),
        grace_days_allowed: Number(this.grace_days_allowed),
        lunch_break_minutes: Number(this.lunch_break_minutes),
        is_active: this.status ? 1 : 0,
      }

      let response = null
      if (this.id) {
        response = await this.getHTTPPutResponse(
          `admin/master/shift/update/${this.id}`,
          input,
          true,
        )
      } else {
        response = await this.getHTTPPostResponse(
          'admin/master/shift/create',
          input,
          true,
        )
      }

      if (response && response.status === 200) {
        this.$root.$emit('bv::toggle::collapse', 'addEditShift')
        this.$emit('shiftSaved', true)
      }
      this.btnLoader = false
    },

    clearData() {
      this.name = null
      this.code = null
      this.start_time = null
      this.end_time = null
      this.working_hours = null
      this.minimum_full_day_hours = '00:00'
      this.grace_period_start_hours = '00:00'
      this.half_day_hours = '00:00'
      this.working_days = []
      this.weekly_off_days = []
      this.grace_minutes = null
      this.lunch_break_minutes = null
      this.status = true
      this.endTimeError = false
      this.minFullDayError = false
      this.gracePeriodStartError = false
      this.halfDayError = false
      this.minFullDayOverError = false
      this.gracePeriodStartOverError = false
      this.halfDayOverError = false
      this.workingDaysError = false
      this.workingDayOverlapError = false
      this.weeklyOffOverlapError = false
      this.$refs.shiftObserver.reset()
    },
  },
}
